<script>
import Pagination from '@/components/Pagination';
import RowBlockSkeleton from "@/views/reissue/components/RowBlockSkeleton";
import displaySettings from "@/mixin/displaySettings";
import {getWithdrawalRequest} from "@/api/withdrawalRequest";

export default {
	name: "index",
	components: {RowBlockSkeleton, Pagination},
	mixins: [displaySettings],
	data() {
		return {
			data: [],
			meta: {},
			loading: false,
		}
	},
	methods: {
		getData() {
			this.loading = true;
            getWithdrawalRequest().then(response => {
				this.data = response.data.data;
				this.meta = response.data.meta
				this.loading = false;
			})
		},
        getStatusName(status) {
            switch (status) {
                case 0:
                    return 'Очікує';
                case 1:
                    return 'Перевірено'
                case 2:
                    return 'Виплачено'
                case 3:
                    return 'Відхилений'
                default:
                    return '';
            }
        },
		getStatusClass(status) {
			switch (status) {
				case 0:
					return 'pending';
				case 1:
					return 'checked'
				case 2:
					return 'completed'
				case 3:
					return 'rejected'
				default:
					return '';
			}
		},
	},
	mounted() {
		this.getData();
	}
}
</script>

<template>
	<div>
		<div v-if="isMobile">
			<el-collapse :accordion="true" class="withdrawal-mobile-columns-block">
				<el-collapse-item v-for="item in data" :key="item.id" class="order-data">
					<template #title>
						<div class="w-100">
							<el-row align="middle" class="info-block">
								<el-col :span="12">
									<div><b>ID</b></div>
									<div>
										{{ item.id }}
									</div>
								</el-col>

                                <el-col :span="12">
                                    <div>
                                        <b>Запит створений:</b>
                                    </div>
                                    <div>{{ item.createdAt }}</div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="">
                                        <div>
                                            <span>Статус:</span>
                                        </div>
                                        <div :class="['status', `status-${getStatusClass(item.status)}`]">{{ getStatusName(item.status) }}</div>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <b>Сума, грн</b>
                                    <el-col>
                                        <div class="amount">{{ item.amount }} грн</div>
                                    </el-col>
                                    <el-col>
                                        <span>сумма до отримання:</span>
                                        <span class="amount-actual">{{ item.amount_actual }}</span>
                                    </el-col>
                                </el-col>
                                <el-col :span="12">
                                    <div>
                                        <b>Торгова точка</b>
                                    </div>
                                    {{ item.userInfo.full_name }}
                                </el-col>

							</el-row>
						</div>
					</template>
					<div>
						<el-row :gutter="5">
							<el-col>
								<el-row>
									<el-col>
										<b>Дата</b>
									</el-col>
									<el-col>
                                        <span>Запит створений:</span>
                                        {{ item.createdAt }}
									</el-col>
								</el-row>
							</el-col>
							<el-col>
								<el-row>
									<el-col><b>Торгова точка</b></el-col>
									<el-col>
										<el-col>
											{{ item.userInfo.full_name }}
										</el-col>
									</el-col>
								</el-row>
							</el-col>
							<el-col>
								<el-row>
									<el-col><b>Сума, грн</b></el-col>
									<el-col>{{ item.amount }} грн</el-col>
                                    <el-col>
                                        <span>сумма до отримання:</span>
                                        {{ item.amount_actual }}
                                    </el-col>
								</el-row>
							</el-col>
                            <el-col>
                                <el-row>
                                    <el-col><b>Деталі</b></el-col>
                                    <el-col v-if="item.data !== null">
                                        <el-col v-if="item.data.recipientName">
                                            <div>Отримувач: {{ item.data.recipientName }}</div>
                                        </el-col>
                                        <el-col v-if="item.data.recipientBankName">
                                            <div>Назва банку: {{ item.data.recipientBankName }}</div>
                                        </el-col>
                                        <el-col v-if="item.data.recipientCode">
                                            <div>Код отримувача: {{ item.data.recipientCode }}</div>
                                        </el-col>
                                        <el-col v-if="item.data.recipientAccount">
                                            <div>IBAN: {{ item.data.recipientAccount }}</div>
                                        </el-col>
                                        <el-col v-if="item.data.recipientBankCard">
                                            <div>Номер картки: {{ item.data.recipientBankCard }}</div>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col>
                                <el-row>
                                    <el-col><b>Примітки</b></el-col>
                                    <el-col v-if="item.comment !== null">
                                        <div v-if="item.comment">
                                            <span>Коментарій:</span>
                                            <div>{{ item.comment }}</div>
                                        </div>
                                    </el-col>
                                    <el-col v-if="item.result !== null">
                                        <div v-if="item.result.reason">
                                            <span>Причина відхилення:</span>
                                            <div>{{ item.result.reason }}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-col>
						</el-row>
					</div>
				</el-collapse-item>
			</el-collapse>
		</div>
		<div v-else class="list">
			<div class="header-block">
				<ul class="columns-block">
					<li class="column">ID</li>
					<li class="column">Дата</li>
					<li class="column">Торгова точка</li>
					<li class="column">Сума, грн</li>
					<li class="column">Деталі</li>
                    <li class="column">Примітки</li>
				</ul>
			</div>
			<div v-if="loading">
				<row-block-skeleton v-for="item in 4" :key="item"/>
			</div>
			<div v-else>
				<div class="row-block" v-for="item in data">
					<ul class="columns-block">
						<li class="column">
							<el-col>
								{{ item.id }}
							</el-col>
							<el-col class="right-border">
								<div class="d-flex align-middle">
									<div>
										<span>Статус:</span>
									</div>
									<div :class="['status', `status-${getStatusClass(item.status)}`]">{{ getStatusName(item.status) }}</div>
								</div>
							</el-col>
						</li>
						<li class="column">
							<el-row>
								<el-col>
									<span>Запит створений:</span>
									{{ item.createdAt }}
								</el-col>
							</el-row>
<!--							<el-row>-->
<!--								<el-col class="right-border">-->
<!--									<span>СК:</span>-->
<!--									{{ item.order.companyName }}-->
<!--								</el-col>-->
<!--							</el-row>-->
						</li>
						<li class="column">
							<el-row>
								<el-col>{{ item.userInfo.full_name }}</el-col>
							</el-row>
						</li>
						<li class="column">
                            <el-row>
                                <el-col class="right-border">
                                    {{ item.amount }} грн
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <span>сумма до отримання:</span>
                                    {{ item.amount_actual }}
                                </el-col>
                            </el-row>
                        </li>
                        <li class="column">
                            <el-col v-if="item.data !== null">
                                <el-col v-if="item.data.recipientName">
                                    <div>Отримувач: {{ item.data.recipientName }}</div>
                                </el-col>
                                <el-col v-if="item.data.recipientBankName">
                                    <div>Назва банку: {{ item.data.recipientBankName }}</div>
                                </el-col>
                                <el-col v-if="item.data.recipientCode">
                                    <div>Код отримувача: {{ item.data.recipientCode }}</div>
                                </el-col>
                                <el-col v-if="item.data.recipientAccount">
                                    <div>IBAN: {{ item.data.recipientAccount }}</div>
                                </el-col>
                                <el-col v-if="item.data.recipientBankCard">
                                    <div>Номер картки: {{ item.data.recipientBankCard }}</div>
                                </el-col>
                            </el-col>
                        </li>
                        <li class="column">
                            <el-col v-if="item.comment !== null">
                                <div v-if="item.comment">
                                    <span>Коментарій:</span>
                                    <div>{{ item.comment }}</div>
                                </div>
                            </el-col>
                            <el-col v-if="item.result !== null">
                                <div v-if="item.result.reason">
                                    <span>Причина відхилення:</span>
                                    <div>{{ item.result.reason }}</div>
                                </div>
                            </el-col>
                        </li>
					</ul>
				</div>
			</div>
		</div>

		<pagination v-if="meta.total > 0"
								:total="meta.total"
								:page.sync="meta.current_page"
								:limit.sync="meta.per_page" @pagination="getData()"
								class="text-center"
		/>
	</div>
</template>

<style lang="scss" scoped>
@import "./styles/list";
</style>
<style scoped>
* >>> .el-collapse-item__header {
	height: auto;
	line-height: unset;
	&:nth-child(2n+1) {
		background: #F6F7FB;
	}
}
span {
	color:#999DA6;
}
</style>
